
























































import {logout, getUserById} from '@/api/user'
import {setToken} from '@/util/common'
import {Component, Vue, Provide} from 'vue-property-decorator'
import Util from '../util/'
import AppLocales from './AppLocales.vue'
import router from '@/router'

//引入组件
@Component({
    components: {
        AppLocales
    }
})
export default class AppToolbar extends Vue {

    private welcome: string = '欢迎您！'
    private displayName: string = ''

    //data
    @Provide() items: object = [
        {
            icon: 'account_circle',
            href: '#',
            title: '个人信息',
            click: (e: any) => {
                router.replace({name: 'Profile'})
            }
        },
        {
            icon: 'settings',
            href: '#',
            title: '修改密码',
            click: (e: any) => {
                router.replace({name: 'UpdatePwd'})
            }
        },
        {
            icon: 'exit_to_app',
            href: '#',
            title: '退出',
            click: (e: any) => {
                logout().then(() => {
                    setToken("")
                    router.replace({name: 'Login'})
                })
            }
        }
    ]

    //methods
    handleDrawerToggle() {
        this.$emit("side-icon-click")
    }

    handleFullScreen() {
        Util.toggleFullScreen()
    }

    //生命周期
    mounted() {
        const loginUser = this.$store.state.loginUser

        if (loginUser) {
            getUserById(loginUser.userId).then((data: any) => {
                if (data) {
                    this.displayName = data.displayName
                    this.welcome = data.displayName + "，欢迎您！"
                }
            })
        }
    }
}
